import * as React from 'react'

import type { AvatarUser } from 'modules/notifications/hooks/useNotificationsRequests'
import {
  BaseRequestItem,
  RequestComponentProps,
} from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/base'

interface Props extends RequestComponentProps {
  avatarUsersMap?: Map<string, AvatarUser>
}

const Request = ({ request, index, compact, avatarUsersMap }: Props) => {
  return (
    <BaseRequestItem
      request={request}
      index={index}
      compact={compact}
      avatarUsersMap={avatarUsersMap}
      {...(request.actionUrl && { url: request.actionUrl })}
      {...(request.remoteUrl && { remoteUrl: request.remoteUrl })}
    />
  )
}

export default Request
